<template>
  <ul class="tabnav__tabs">
    <li
      v-for="(tab, index) in tabs"
      :key="index"
      class="tabnav__tabs-item"
    >
      <router-link
        :id="'tab-' + index"
        :to="tab.path"
      >
        {{ tab.name }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TabNavigation',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.tabnav {
  &__tabs {
    @include flex-display();
    list-style: none;
    padding: 0;
    width: 100%;
    margin-bottom: 3em;
    &-item {
      a {
        padding: 1em 2.5em;
        border-bottom: 1px solid $light-grey;
        color: $grey-text;
        text-transform: uppercase;
        font-weight: 600;
        font-size: $small-font;
        text-decoration: none;
        &.router-link-active {
          color: $black;
          border-bottom: 3px solid $green;
        }
        &:hover {
          color: $black;
        }
      }
    }
  }
}
</style>
